import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { usePullToRefresh } from './usePullToRefresh';
import DefaultLoading from './DefaultLoading';

export interface IPullToRefreshProps {
  disabled: boolean;
  handler: AnyAsyncFunction;
  children?: React.ReactNode;
  Loading?: React.FC;
}

const PullToRefresh: React.FC<IPullToRefreshProps> = ({
  disabled,
  handler,
  children,
  Loading = DefaultLoading,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [PullToRefreshState, setDisabled, updateHandler] = usePullToRefresh({
    ref: ref,
    disabled,
    handler,
  });

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  useEffect(() => {
    updateHandler(handler);
  }, [handler]);

  return (
    <div
      className={clsx('jarvis-PullToRefresh', {
        PullToRefresh__transition: PullToRefreshState.dropped,
      })}
      ref={ref}
    >
      {(PullToRefreshState.status === 'active' ||
        PullToRefreshState.status === 'loading') && (
        <div className="jarvis-PullToRefresh__loading">
          <Loading />
        </div>
      )}
      {React.Children.only(children)}
    </div>
  );
};

export default PullToRefresh;
